<div class="flex-column full-height gap-16">
  <div class="flex-space-between">
    <p class="b1 font-weight-semibold">{{ 'GENERAL.SELECTED' | bmsTranslate }} {{ 'BMSCONFIG.RESOURCE_TYPES.RESOURCE_TYPE' | bmsTranslate: {count: 2} | lowercase }}</p>
    <vdw-split-button
      [label]="'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'BMSCONFIG.RESOURCE_TYPES.RESOURCE_TYPE' | bmsTranslate: {count: 1} | lowercase}"
      [stroked]="true"
      [disabled]="isLoading || !canEdit"
      [withOpenDropdown]="true"
    >
      <button mat-menu-item (click)="selectMachine()">{{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase} }}</button>
      <button mat-menu-item (click)="showMachineGroup ? selectMachineGroup() : selectMachineType()">
        {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: (showMachineGroup ? 'PLANNING.MACHINE_GROUP' : 'MACHINE.DETAILS.MACHINE_TYPE') | bmsTranslate | lowercase} }}
      </button>
    </vdw-split-button>
  </div>
  <vdw-crud-overview-data-page [config]="config" [canShowActions]="false"></vdw-crud-overview-data-page>
</div>
